// extracted by mini-css-extract-plugin
export var addToCartButton = "_ui-b";
export var arrowButtonContainer = "_ui-9";
export var arrowButtonIcon = "_ui-a";
export var carouselArrowButton = "_ui-6";
export var carouselElementContainer = "_ui-1";
export var left = "_ui-7";
export var productDisplayCarouselContainer = "_ui-0";
export var productTileContainer = "_ui-2";
export var productTileImage = "_ui-4";
export var productTileImageContainer = "_ui-3";
export var productTileTitle = "_ui-5";
export var right = "_ui-8";
export var sliderOverflow = "_ui-c";